// If VFs are supported loads fonts based on font_file_id which might repeat per style

import { IFontStyleModel } from '../classes';

// Otherwise loads individual fonts based on the unique style id
export function getFontName(style: IFontStyleModel): string {
    return style ? `_${style.font_file_id}` : '';
}
